import { lazy } from 'react';
const ChatAiRoutes = [
    {
        label: '机器人',
        key: 'chatAi',
        show: true,
        path: '/public/chatAiThird',
        element: lazy(() => import('@/page/ChatUi3.0'))
    },
    {
        key: 'lectureHall', //独立直播
        path: '/public/lectureHall',
        show: true,
        element: lazy(() => import('@/page/PublicLectureHall'))
    }
];
export default ChatAiRoutes;
